import template from './llm-model-select.html.twig';

const { Component, Data } = Shopware;
const { Criteria } = Data;

Component.register('tdlc-llm-model-select', {
    template,
    props: {
        value: { type: String, required: false },
    },
    emits: ['change'],
    data() {
        return { options: [] };
    },
    created() {
        const repo = Shopware.Service('repositoryFactory').create('tdlc_llm_model');
        const criteria = new Criteria();
        criteria.addFilter(Criteria.equals('active', true));
        criteria.addAssociation('provider');
        repo.search(criteria).then((res) => {
            const mapped = res.map((m) => ({
                value: m.id,
                label: `${m.displayName} (${m.provider?.prefix ?? '?'})`,
                favorite: !!m.isFavorite,
            }));
            // Favorites first, then alphabetical — stable, consistent ordering.
            mapped.sort((a, b) => {
                if (a.favorite !== b.favorite) {
                    return a.favorite ? -1 : 1;
                }
                return a.label.localeCompare(b.label);
            });
            this.options = mapped;
        });
    },
    methods: {
        onChange(v) {
            this.$emit('change', v);
        },
    },
});
